<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">Management Produk</h2>
      <v-spacer></v-spacer>
      <div class="listtotal mt-2">
      </div>
      <v-tabs  v-model="tab">
        <v-tab><v-badge color="green" :content="totalproduct">Produk</v-badge></v-tab>
        <v-tab><v-badge color="green" :content="totalbrand">Brand</v-badge></v-tab>
        <v-tab><v-badge color="green" :content="totalcategory">Category</v-badge></v-tab>
         <v-tab><v-badge color="green" :content="0">BrandGroup</v-badge></v-tab>
        <v-tab-item>
          <MasterProducts/>
        </v-tab-item>
        <v-tab-item>
          <Brands/>
        </v-tab-item>
        <v-tab-item>
          <Category/>
        </v-tab-item>
        <v-tab-item>
          <BrandGroup/>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import BrandGroup from '@/components/admin/product/BrandGroup'
import Brands from '@/components/admin/product/Brands'
import { mapState } from 'vuex'
import Category from '@/components/admin/product/Category'
import MasterProducts from '@/components/admin/product/Products'

export default {
  name: 'AdminProduct',
  components: { MasterProducts, Category, Brands, BrandGroup },
  data: () => ({
    tab: null
  }),
  mounted () {
  },
  computed: {
    ...mapState('AdminProducts', ['totalbrand', 'totalcategory', 'totalproduct'])

  }
}
</script>

<style scoped>

</style>
